import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { IconComponent } from '../shared/components/icon/icon.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import {
    ACCOUNT_ROUTE, CERTIFICAZIONI_ROUTE, HOME_ROUTE, LOGOUT_ROUTE, NOTIFICHE_ROUTE, NUOVA_PRATICA_ROUTE, POSIZIONE_ROUTE, PRATICHE_ROUTE,
} from '../core/routes';
import { AderenteApiService } from '../core/aderente-api.service';

// bottomSlot: colonna della bottom-nav mobile (mockup: 1 Home · 2 Pratiche · 3 FAB Nuova · 4 Certificati · 5 Posizione)
interface NavItem { label: string; shortLabel: string; icon: string; route: string; bottomSlot: number; }

/**
 * Shell area aderente (STILE-VISUALE.md §4.2, mockup le-mie-pratiche-aderente.html): topbar scura con nav a pillole,
 * "Nuova pratica", notifiche, utente, "Il mio account" e uscita su desktop; su mobile topbar ridotta e bottom-nav
 * con FAB. Menu completo: le pagine non ancora sviluppate hanno già la voce (vedi core/routes.ts).
 */
@Component({
    selector: 'app-portal-layout',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, RouterLink, RouterLinkActive, NzButtonModule, IconComponent],
    templateUrl: './portal-layout.component.html',
    styleUrl: './portal-layout.component.less',
})
export class PortalLayoutComponent {
    private api = inject(AderenteApiService);
    me = toSignal(this.api.me$, { initialValue: null });

    readonly nuovaPratica = NUOVA_PRATICA_ROUTE;
    readonly notifiche = NOTIFICHE_ROUTE;
    readonly account = ACCOUNT_ROUTE;
    readonly logout = LOGOUT_ROUTE;

    readonly nav: NavItem[] = [
        { label: 'Home',             shortLabel: 'Home',       icon: 'home',              route: HOME_ROUTE,           bottomSlot: 1 },
        { label: 'Le mie pratiche',  shortLabel: 'Pratiche',   icon: 'assignment',        route: PRATICHE_ROUTE,       bottomSlot: 2 },
        { label: 'La mia posizione', shortLabel: 'Posizione',  icon: 'badge',             route: POSIZIONE_ROUTE,      bottomSlot: 5 },
        { label: 'Certificazioni',   shortLabel: 'Certificati', icon: 'workspace_premium', route: CERTIFICAZIONI_ROUTE, bottomSlot: 4 },
    ];

    initials = computed(() => {
        const m = this.me();
        return m ? (m.nome[0] + m.cognome[0]).toUpperCase() : '';
    });
}
